export default __webpack_public_path__ + "static/hodl-hands-3c9b60deef4390ce1066e4fbfbc5437c.svg";